import PageProtectedLayout from "../../../components/Page/PageProtectedLayout";
import MedicationPanel from "./MedicationPanel";
import { useTranslation } from '../../../language';

export default function SubscriptionWelcome() {

  const { t } = useTranslation();

return (

<PageProtectedLayout

    headline={t('page_hl_account')}
    specify={t('page_sp_medication_list')}

     >

 {/* Main Page Content */}
      <MedicationPanel />

</PageProtectedLayout>

)}
